import debounce from 'lodash/debounce';
import { useEffect, useMemo } from 'react';

/**
 * Хук для создания debounced версии функции
 * @param callback - Функция для debounce
 * @param delay - Задержка в миллисекундах
 * @returns Debounced функция
 */
export const useDebounce = <TArgs extends unknown[]>(callback: (...args: TArgs) => void, delay: number = 300) => {
    const debouncedCallback = useMemo(() => debounce(callback, delay), [callback, delay]);

    useEffect(() => {
        return () => {
            debouncedCallback.cancel();
        };
    }, [debouncedCallback]);

    return debouncedCallback;
};
